import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useInquiryDialog } from "@/context/InquiryDialogContext";
import { BrandLogo } from "@/components/BrandLogo";
import DesktopNav from "@/components/nav/DesktopNav";
import MobileNav from "@/components/nav/MobileNav";

const Navbar = () => {
  const { openDialog } = useInquiryDialog();
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleOpenInquiry = () => {
    setMobileOpen(false);
    openDialog();
  };

  // Logo click: if already on the homepage, just smooth-scroll to the top instead of
  // letting react-router push a redundant "/" -> "/" history entry (no route
  // reload needed). If on any other page, let the normal <Link to="/"> navigation
  // happen - ScrollManager already resets the new page to the top on that PUSH.
  const handleLogoClick = (e) => {
    setMobileOpen(false);
    if (location.pathname === "/") {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-[color:hsl(var(--background))] shadow-[0_1px_0_0_rgba(43,43,43,0.08)]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] md:h-20 flex items-center justify-between gap-4">
        <BrandLogo
          linkTestId="navbar-logo-link"
          imgTestId="navbar-logo"
          iconClassName="h-10 md:h-[45px] w-auto"
          onClick={handleLogoClick}
        />

        <DesktopNav onOpenInquiry={() => openDialog()} />
        <MobileNav open={mobileOpen} onOpenChange={setMobileOpen} onOpenInquiry={handleOpenInquiry} />
      </div>
    </header>
  );
};

export default Navbar;
